import { Avatar, Box, Flex, Text, useColorModeValue, IconButton, Icon } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React from "react";
import { MdEdit } from "react-icons/md";
import { useUser } from "contexts/UserContext";

export default function Banner(props) {
  const { banner, avatar, name, plan, requests, remaining, resetTime } = props;

  const { setUser } = useUser();
  const textColorPrimary = useColorModeValue("#1B2559", "#FFFFFF");
  const textColorSecondary = useColorModeValue("#4A5568", "#A3AED0");
  const borderColor = useColorModeValue("#FFFFFF !important", "#111C44 !important");

  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(name || "User")}&background=6C63FF&color=fff`;

  const handleEditClick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setUser(prev => ({ ...prev, avatar: reader.result }));
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  return (
    <Card mb={{ base: "0px", lg: "20px" }} align='center'>
      <Box
        bg={`url(${banner})`}
        bgSize='cover'
        borderRadius='16px'
        h='131px'
        w='100%'
      />

      <Box position="relative" w='87px' h='87px' mx='auto' mt='-43px'>
        <Avatar
          src={avatar || avatarUrl}
          h='87px'
          w='87px'
          border='4px solid'
          borderColor={borderColor}
        />
        <IconButton
          icon={<Icon as={MdEdit} />}
          size="sm"
          colorScheme="brand"
          borderRadius="full"
          position="absolute"
          bottom="-5px"
          right="-5px"
          onClick={handleEditClick}
          aria-label="Edit Profile Image"
          shadow="md"
        />
      </Box>

      <Text color={textColorPrimary} fontWeight='bold' fontSize='xl' mt='10px'>
        {name}
      </Text>

      <Text color={textColorSecondary} fontSize='sm' textTransform="capitalize" fontWeight="500">
        {plan} User
      </Text>

      <Flex w='max-content' mx='auto' mt='26px'>
        <Flex mx='auto' me='60px' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {requests}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Requests Today
          </Text>
        </Flex>

        <Flex mx='auto' me='60px' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {remaining}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Remaining Today
          </Text>
        </Flex>

        <Flex mx='auto' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {resetTime}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Refresh In
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
}
